import { SUPPORTED_LANGUAGE_CODES } from '@logicalcommander/types';

export const stagingEnv = {
  api: {
    GATEWAY_URL: 'https://staging.e-commander.com/api/v1',
    CDN_CONTENT_URL: 'https://du0ofv074neex.cloudfront.net',
    PDFJS_WORKER_URL: '/libs/pdf.worker.js',
    GENERATE_SOURCEMAP: 'false',
    REACT_APP_CAPTCHA_SITE_KEY: '6LfQ8LEqAAAAAGyeeAoEJ2enhAG9ZilcOG52plQX',
    SUPPORT_LINK: 'https://logical-commander-software.atlassian.net/servicedesk/customer/portal/7',
    REACT_APP_SMARTLOOK_ENABLED: 'true',
    REACT_APP_SMARTLOOK_SESSION_REPLAY_COMPANIES: 'all'
  },
  legalDocs: {
    SLA: "/public/e-commander/docs/legal/sla/sla.pdf", // Service Level Agreement
    DPA: "/public/e-commander/docs/legal/dpa/dpa.pdf", // Data Processing Agreement
    CCPA: "/public/e-commander/docs/legal/ccpa/ccpa.pdf", // CCPA Privacy notice
    SAAS: "/public/e-commander/docs/legal/saas/saas.pdf", // Software as a Service Agreement
    PRIVACY_POLICY: "/public/e-commander/docs/legal/pp/privacy-policy.pdf", // Privacy Policy
    SOFTWARE_LICENSE_SERVICES_AGREEMENT: "/public/e-commander/docs/software-license-services-agreement/software_license_services_agreement_v1.04.pdf",
    BILLING_TAX_REFUND_POLICY: "/public/e-commander/docs/billing-tax-refund-policy/billing_tax_refund_policy_v1.0.1.pdf",
    TERMS_AND_CONDITIONS: "/public/e-commander/docs/terms-and-conditions/risk-hr-admin/terms_and_conditions_v1.0.4.pdf",
    CHATBOT_DISCLAIMER: "/public/e-commander/docs/legal/chat-disclaimer/Chatbot%20Disclaimer_v1.0.0.pdf",
  },
  otherDocs: {
    USER_MANUAL_EN: "/public/e-commander/docs/user-guide/user-guide-en.pdf", // User Manual
    USER_MANUAL_ES: "/public/e-commander/docs/user-guide/user-guide-es.pdf", // User Manual
  },
  /** Tour video paths (relative to CDN_CONTENT_URL). Platform + page-specific help videos by language. */
  tour: {
    platform: {
      en: "/public/e-commander/videos/tour/en/E-Commander%20Full%20Tour.mp4",
      es: "/public/e-commander/videos/tour/es/E-Commander%20Visio%CC%81n%20General%20de%20la%20Plataforma.mp4",
    },
    pages: {
      "general-dashboard": {
        en: "/public/e-commander/videos/tour/en/Page%20tour%20General%20Dashboard.mp4",
        es: "/public/e-commander/videos/tour/es/E-Commander%20Tour%20%20-%20Dashboard%20General.mp4",
      },
      "my-dashboard": {
        en: "/public/e-commander/videos/tour/en/Page%20tour%20My%20Dashboard.mp4",
        es: "/public/e-commander/videos/tour/es/E-Commander%20Tour%20%20-%20Mi%20Tablero.mp4",
      },
      "riskhr-dashboard": {
        en: "/public/e-commander/videos/tour/en/Page%20tour%20Risk-HR%20Dashboard.mp4",
        es: "/public/e-commander/videos/tour/es/E-Commander%20Tour%20%20-%20Risk-HR%20Tablero.mp4",
      },
      users: {
        en: "/public/e-commander/videos/tour/en/Page%20Tour%20Employees.mp4",
        es: "/public/e-commander/videos/tour/es/E-Commander%20Tour%20%20-%20Empleados.mp4",
      },
      "riskhr-assessments": {
        en: "/public/e-commander/videos/tour/en/Page%20tour%20Assessments.mp4",
        es: "/public/e-commander/videos/tour/es/E-Commander%20Tour%20%20-%20Evaluaciones.mp4",
      },
      "riskhr-cases": {
        en: "/public/e-commander/videos/tour/en/Page%20Tour%20Cases.mp4",
        es: "/public/e-commander/videos/tour/es/E-Commander%20Tour%20%20-%20Casos.mp4",
      },
      reports: {
        en: "/public/e-commander/videos/tour/en/Page%20Tour%20Reports.mp4",
        es: "/public/e-commander/videos/tour/es/E-Commander%20Tour%20%20-%20Informes.mp4",
      },
      settings: {
        en: "/public/e-commander/videos/tour/en/Page%20Tour%20Settings.mp4",
        es: "/public/e-commander/videos/tour/es/E-Commander%20Tour%20%20-%20Configuracion.mp4",
      },
    },
  },
  legalDocsVersions: {
    SLA: "7736105.1",
    DPA: "1.0.0",
    CCPA: "1.0.0",
    SAAS: "7736072.2",
    PRIVACY_POLICY: "1.0.0",
    SOFTWARE_LICENSE_SERVICES_AGREEMENT: "1.0.4",
    BILLING_TAX_REFUND_POLICY: "1.0.1",
    TERMS_AND_CONDITIONS: "1.0.4",
    CHATBOT_DISCLAIMER: "1.0.0",
  },
  SHORT_DATE_FORMAT: 'DD/MM/YYYY',
  SHORT_TIME_FORMAT: 'HH:mm:ss',
  SHORT_DATE_CALENDAR_FORMAT: 'YYYY-MM-DD',
  LONG_DATE_FORMAT: 'DD/MM/YYYY HH:mm:ss',
  FUTURE_FEATURES: false,
  NODE_OPTIONS: '--max-old-space-size=8192',
  SUPPORTED_LANGUAGES: [...SUPPORTED_LANGUAGE_CODES],
  NOTIFICATIONS_POLLING_INTERVAL_MS: 60000,
  SESSION_TIMEOUT_MS: 3600000,
  SESSION_EXPIRY_WARNING_MS: 300000,
  mitigationPolicy: {
    MIN_FILE_SIZE: 100,
    MAX_FILE_SIZE_BYTES: 5 * 1024 * 1024,
    MAX_FILE_SIZE_MB: 5,
    ACCEPT: '.pdf,.doc,.docx',
  },
}

export const appConfig = stagingEnv